/* eslint-disable @typescript-eslint/no-unused-vars */
import { CustomToastContainer } from 'components/Basic/CustomToast';
import Tool from 'components/tool';
import { StageWrap } from 'components/tool/styles';
import { forwardRef, useEffect, useRef } from 'react';
import EscapeKeyHandler from './EscapeKeyHandler';
import ImageEditor from 'components/ImageEditor';
import TreeSidePanel from 'components/Tree/TreeSidePanel';
import FlattenAreaSidePanel from 'components/FlattenArea/FlattenAreaSidePanel';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useSaveDesign } from 'hooks/api/useSaveDesign';
import { useRefs } from 'contexts/RefContext';
import { TOOL_RENDER_MODE } from '../../constants';

interface ToolContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

// TODO: refactor Tool component move all non stage fn here
// from Tool compoennt like zoom, strip etc...
const ToolContainer = forwardRef<HTMLDivElement, ToolContainerProps>(({ children }, ref)=>{
	const { designType } = useSelector((state: RootState) => state.roofData.data);
	const { toolRenderMode } = useSelector((state: RootState) => state.QueryParams.data);
	const { save: autoSaveDesign } = useSaveDesign(designType);
	const { konvaRef } = useRefs();
	const hasSaved = useRef<boolean>(false);
	const autoSaveDesignRef = useRef(autoSaveDesign);
	autoSaveDesignRef.current = autoSaveDesign;

	useEffect(() => {
		if (toolRenderMode === TOOL_RENDER_MODE.BACKGROUND && konvaRef && !hasSaved.current) {
			hasSaved.current = true;
			setTimeout(() => {
				autoSaveDesignRef.current();
			}, 1500);
		}
	}, [toolRenderMode, konvaRef]);

	return(
		<>
			<StageWrap ref={ref}>
				<Tool />
			</StageWrap>

			<ImageEditor/>
			<TreeSidePanel/>
			<FlattenAreaSidePanel/>

			<EscapeKeyHandler/>
			<CustomToastContainer
				containerId='tool-toast'
				className='custom-toast-container'
			/>
		</>
	);
		
});

ToolContainer.displayName = 'ToolContainer';

export default ToolContainer;
